import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loading-text',
  templateUrl: './loading-text.component.html',
  styleUrls: ['./loading-text.component.scss']
})
export class LoadingTextComponent implements OnInit {
  @Input() loading: boolean = false;
  @Input() loadingText: string;
  @Input() nonLoadingText: string;

  constructor() { }

  ngOnInit(): void {
  }
}
